import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { ButtonComponent } from '@modules/components/button/button.component';
import { TABS_COMPONENTS } from '@modules/components/tabs/tabs';
import { dictionaryToOptions } from '@modules/components/select/select-options';
import { SelectComponent } from '@modules/components/select/select.component';
import { OpenFilterDirective } from '@modules/filter/services/open-filter.directive';
import { CompanyCard } from '@type/company.type';
import { LogTab } from '@type/log.type';
import { LogAdminFieldsService } from '../../services/log-admin-fields/log-admin-fields.service';

@Component({
  selector: 'app-log-header',
  imports: [MatToolbarModule, MatIconModule, ButtonComponent, OpenFilterDirective, TABS_COMPONENTS, SelectComponent],
  templateUrl: './log-header.component.html',
  styleUrl: './log-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogHeaderComponent {
  filterOptionsService = inject(LogAdminFieldsService);

  activeTab = input<LogTab>('company');
  companiesList = input<CompanyCard[]>([]);
  selectedCompanyId = input<number | null>(null);

  tabChanged = output<LogTab>();
  companyChanged = output<number>();

  protected companyOptions = computed(() => dictionaryToOptions(this.companiesList()));

  protected changeTab(tab: LogTab | undefined) {
    if (tab) this.tabChanged.emit(tab);
  }

  protected changeCompany(companyId: number | null) {
    if (companyId === null) return;

    this.companyChanged.emit(companyId);
  }
}
